// Marka tescil künyesi — TEK kaynak (Hakkımızda + Telif Hakkı sayfaları buradan
// okur), `companyInfo.js` ile aynı desen. İki sayfaya elle yazılsaydı biri
// güncellenip öteki unutulurdu; numarayı ya da koruma aralığını değiştiren
// yalnız burayı değiştirir.
//
// Kaynak belge: Türk Patent ve Marka Kurumu, Marka Tescil Belgesi 2026 009778
// (başvuru 24.01.2026, tescil 07.08.2026 — 6769 sayılı Sınai Mülkiyet Kanunu
// kapsamında başvuru tarihinden itibaren 10 yıl koruma).
//
// DOSYA ADINDA NUMARA/TARİH YOKTUR (kullanıcı kararı 14.09.2026): tescil
// numarası "2026 009778" bir tarih gibi okunuyor ve marka yenilendiğinde
// adresin de değişmesi gerekirdi. Numara belgenin İÇİNDE ve künye tablosunda.
import { COMPANY_INFO } from './companyInfo';

export const TRADEMARK = {
  brand: 'Katip Otomasyonu',
  no: '2026 009778',
  classes: '09, 42',
  term: '24.01.2026 – 24.01.2036',
  // Marka sahibi ŞİRKETİN KENDİSİDİR — unvanı ikinci kez yazmayalım.
  owner: COMPANY_INFO.legalName,
  // Belge SAYFADA görsel olarak gösterilir; PDF indirme bağlantısı YOKTUR ve PDF
  // `public/`ten kaldırıldı (kullanıcı kararı 14.09.2026).
  image: '/marka-tescil-belgesi-katip-otomasyonu.jpg',
  // Görselin GERÇEK piksel ölçüsü; <img>'e yazılır ki tarayıcı yer ayırsın,
  // yoksa belge yüklenirken sayfa zıplar. Görseli değiştirirsen bunları da güncelle.
  imageWidth: 1240,
  imageHeight: 1755,
};

// Etiket–değer sırası; iki sayfa da AYNI sırayı çizer.
export const TRADEMARK_FACTS = [
  ['Tescil No', TRADEMARK.no],
  ['Mal / Hizmet Sınıfları', TRADEMARK.classes],
  ['Koruma Süresi', TRADEMARK.term],
  ['Marka Sahibi', TRADEMARK.owner],
];

export const TRADEMARK_CAPTION = 'Türk Patent ve Marka Kurumu — Marka Tescil Belgesi';

export const TRADEMARK_ALT =
  'Katip Otomasyonu markasının Türk Patent ve Marka Kurumu tarafından düzenlenen Marka Tescil Belgesi';

// Hakkımızda: tek cümlelik künye. Orası bir tanıtım sayfasıdır, ihlal uyarısının yeri değil.
export const TRADEMARK_SUMMARY =
  '"Katip Otomasyonu" markası, Türk Patent ve Marka Kurumu nezdinde şirketimiz adına tescillidir ve 6769 sayılı Sınai Mülkiyet Kanunu kapsamında korunmaktadır.';

// Telif Hakkı: hukuki sonucu da söyleyen tam metin.
export const TRADEMARK_NOTE = `${TRADEMARK_SUMMARY} Marka adının, logosunun veya bunlarla karıştırılabilecek işaretlerin izinsiz kullanılması hukuki sorumluluk doğurur.`;
